import React from 'react';

interface Props {
  className?: any;
}

export const CalendarModalDeleteIcon: React.FC<Props> = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.625 9.625H6.875V17.875H9.625V9.625Z" fill="#FF5473" />
      <path d="M15.125 9.625H12.375V17.875H15.125V9.625Z" fill="#FF5473" />
      <path
        d="M16.5 1.375C16.5 0.55 15.95 0 15.125 0H6.875C6.05 0 5.5 0.55 5.5 1.375V4.125H0V6.875H1.375V20.625C1.375 21.45 1.925 22 2.75 22H19.25C20.075 22 20.625 21.45 20.625 20.625V6.875H22V4.125H16.5V1.375ZM8.25 2.75H13.75V4.125H8.25V2.75ZM17.875 6.875V19.25H4.125V6.875H17.875Z"
        fill="#FF5473"
      />
    </svg>
  );
};
